import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import './profile.scss'
import iconArrowDownDark from '../../../../assets/icons/arrow-down-dark.svg'
import imageAvatar from '../../../../assets/images/avatar.png'
import { AUTH_SAVE } from '../../../../redux/reducers/auth/action-types'

export const logout = (history, dispatch) => {
    sessionStorage.removeItem('auth')
    if (dispatch) {
        dispatch({
            type: AUTH_SAVE,
            payload: {}
        })
    }
    if (history) {
        history.push('/auth/login')
    }
}

const Profile = (props) => {
    return (
        <div className="profile">
            <div>
                <div className="img-cont">
                    <img src={imageAvatar} alt="" />
                </div>
                <strong>{props.auth.profile.firstname} {props.auth.profile.lastname}</strong>
                <img className="arrow-down" src={iconArrowDownDark} alt="" />
                <div className="clearfix"></div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth
    }
}

export default connect(mapStateToProps)(withRouter(Profile))